import { render, staticRenderFns } from "./ExtraBadge.vue?vue&type=template&id=75763860&scoped=true&"
import script from "./ExtraBadge.vue?vue&type=script&lang=js&"
export * from "./ExtraBadge.vue?vue&type=script&lang=js&"
import style0 from "./ExtraBadge.vue?vue&type=style&index=0&id=75763860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75763860",
  null
  
)

export default component.exports